export const jackpotBetWidgetController = {
  initial: 'controllerIdle',
  states: {
    controllerIdle: {
      on: {
        LAYOUT_CHANGE_END: [
          {
            target: 'fetchJackpotBetFeedsByLiquidity',
            cond: 'isJackpotBetWidgetEnabled',
          },
        ],
      },
    },
    fetchJackpotBetFeedsByLiquidity: {
      invoke: {
        src: 'fetchJackpotBetFeedsByLiquidity',
        onDone: [
          {
            actions: ['updateJackpotBetFeeds', 'watchJackpotBetFeeds'],
            target: 'renderComponent',
          },
        ],
      },
    },
    renderComponent: {
      invoke: {
        src: 'prepareJackpotBetWidgetContent',
        onDone: {
          actions: [
            {
              type: 'batchLayoutOperations',
              data: '$event.data.updates',
              meta: {
                selectors: ['$action.data'],
              },
            },
          ],
          target: 'controllerIdle',
        },
      },
    },
  },
};
